import React from 'react';
import { ButtonIcon, Icon, Tooltip } from '@saviynt/design-system';
import cx from 'classnames';

import { useChatOverlayContext } from '../../../context/chatOverlayContext';
import { useIspmErrorContext } from '../../../context/ispmErrorContext';
import { ErrorTypeEnum } from '../../../data-layer/types';
import {
  CHATOVERLAY_HEADER_CLOSEICON,
  CHATOVERLAY_HEADER_RESETICON,
} from '../../../tests/testids';
import { useInvertedLocalize } from '../../../utils/localization';
import { invertedMessages } from '../../../utils/messages';

import './SaviChatHeader.css';

interface SaviChatHeaderProps {
  onChatClose: () => void;
  onChatReset: () => void;
}

function SaviChatHeader({ onChatClose, onChatReset }: SaviChatHeaderProps) {
  const l = useInvertedLocalize(invertedMessages);
  const { chatOverlayState } = useChatOverlayContext();
  const { ispmErrorState } = useIspmErrorContext();

  return (
    <nav
      className={cx(
        'Ispm-SaviChatHeader',
        ispmErrorState.errorType === ErrorTypeEnum.System &&
          'Ispm-SaviChatHeader--isAlertBannnerVisible'
      )}>
      <div className='Ispm-SaviChatHeader-logo'>
        <Icon kind='SaviCompanion' size='medium' color='gray-000' />
        <div className='Ispm-SaviChatHeader-logo-text'>{l('Copilot')}</div>
      </div>
      <div className='Ispm-SaviChatHeader-controls'>
        <Tooltip
          text={l('Reset Chat')}
          placement='bottom'
          trigger={
            <div className='Ispm-SaviChatHeader-controls-buttonIcon'>
              <ButtonIcon
                dataTheme='dark'
                size='large'
                kind='saviGhost'
                icon={<Icon kind='Comment' size='large' />}
                onClick={onChatReset}
                dataTestId={CHATOVERLAY_HEADER_RESETICON}
                isDisabled={
                  chatOverlayState.isApiCallInProgress ||
                  ispmErrorState.errorType === ErrorTypeEnum.System
                }
              />
            </div>
          }
        />
        <Tooltip
          text={l('Close')}
          placement='bottom'
          trigger={
            <div className='Ispm-SaviChatHeader-controls-buttonIcon'>
              <ButtonIcon
                dataTheme='dark'
                size='large'
                kind='saviGhost'
                icon={<Icon kind='Close' size='large' />}
                onClick={onChatClose}
                dataTestId={CHATOVERLAY_HEADER_CLOSEICON}
              />
            </div>
          }
        />
      </div>
    </nav>
  );
}

export default SaviChatHeader;
